var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRiskQuantification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0079 8.992H11.9999V12.992H3.99991V4.992H7.99991V6H5.00791V12H11.0079V8.992ZM12.0319 4.992L12.7039 5.696L8.25591 10L5.99991 7.824L6.67191 7.12L8.25591 8.64L12.0319 4.992ZM13.5039 0.992C13.7812 0.992 14.0159 1.09333 14.2079 1.296C14.3999 1.488 14.4959 1.72267 14.4959 2V15.008C14.4959 15.2747 14.3999 15.504 14.2079 15.696C14.0159 15.8987 13.7812 16 13.5039 16H2.49591C2.22924 16 1.99457 15.8987 1.79191 15.696C1.59991 15.504 1.50391 15.2747 1.50391 15.008V2C1.50391 1.72267 1.59991 1.488 1.79191 1.296C1.98391 1.09333 2.21857 0.992 2.49591 0.992H3.99991V2H2.49591V15.008H13.5039V2H11.9999V0.992H13.5039ZM5.00791 0.992V0H11.0079V0.992H5.00791Z",
    fill: "#474747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskQuantification);
export default __webpack_public_path__ + "static/media/Risk-quantification.bca02916380283f0b2cdaf160caf91cb.svg";
export { ForwardRef as ReactComponent };